import Vue from 'vue';

export default (app, _moduleName, modulePlugins) => {
    if (!modulePlugins) return;

    if (typeof modulePlugins === 'function') return modulePlugins(app);
    if (!Array.isArray(modulePlugins)) return;

    modulePlugins.forEach(plugin => Vue.use(plugin, app));
};
